import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DataEndpoint } from '@core/models/general.model';
import { Observable, map } from 'rxjs';
import { EmissionSourceDetailModel, EmissionSourceFilterModel, EmissionSourceFormulaModel, EmissionSourceHierarchyFilterModel, EmissionSourceHierarchyResponseModel, EmissionSourcePaginatedModel, EmissionSourceExcelTemplateRequestModel } from '../models/emission-source.model';
import { HttpUtils } from '@core/utils/http.utils';

@Injectable({
  providedIn: 'root',
})
export class EmissionSourceApi {
  private readonly http = inject(HttpClient);
  private readonly EMISSION = '/EmissionSource';

  getEmissionSources(request: EmissionSourceFilterModel): Observable<DataEndpoint<EmissionSourcePaginatedModel[]>> {
    const url = `${this.EMISSION}`;
    const params = HttpUtils.objectToHttpParams(request);

    return this.http.get<DataEndpoint<EmissionSourcePaginatedModel[]>>(url, { params })
      .pipe(map((data: DataEndpoint<EmissionSourcePaginatedModel[]>) => {
        return { ...data }
      }));
  }

  getEmissionSourceById(id: string): Observable<DataEndpoint<EmissionSourceDetailModel>> {
    const url = `${this.EMISSION}/${id}`;

    return this.http.get<DataEndpoint<EmissionSourceDetailModel>>(url)
      .pipe(map((data: DataEndpoint<EmissionSourceDetailModel>) => {
        return { ...data }
      }));
  }

  getEmissionSourceHierarchy(request: EmissionSourceHierarchyFilterModel): Observable<DataEndpoint<EmissionSourceHierarchyResponseModel>> {
    const url = `${this.EMISSION}/hierarchy`;
    const params = HttpUtils.objectToHttpParams(request);

    return this.http.get<DataEndpoint<EmissionSourceHierarchyResponseModel>>(url, { params })
      .pipe(map((data: DataEndpoint<EmissionSourceHierarchyResponseModel>) => {
        return { ...data }
      }));
  }

  getEmissionSourceFormulasById(id: string): Observable<DataEndpoint<EmissionSourceFormulaModel>> {
    const url = `${this.EMISSION}/formulas/${id}`;

    return this.http.get<DataEndpoint<EmissionSourceFormulaModel>>(url)
      .pipe(map((data: DataEndpoint<EmissionSourceFormulaModel>) => {
        return { ...data }
      }));
  }

  getEmissionSourceExcelTemplate(sourceId: string, request: EmissionSourceExcelTemplateRequestModel): Observable<string> {
    const url = `${this.EMISSION}/${sourceId}/excel-template`;
    const params = HttpUtils.objectToHttpParams(request);

    return this.http.get(url, { params, responseType: 'text' });
  }

  uploadEmissionSourceExcel(formData: FormData): Observable<DataEndpoint<any>> {
    const url = `${this.EMISSION}/upload-excel`;
    return this.http.post<DataEndpoint<any>>(url, formData);
  }
}
